import React from "react";
import "./Header.css";

function Header() {
  return (
    <header className="header">
      <div className="header-left">
        <img src="logo/logo.png" alt="شعار المطعم" className="logo" />
        <div>
          <h1>LE GREC</h1>
          <p className="subtitle">kebab Berliner</p>
        </div>
      </div>
      <div className="header-right">
        <a href="tel:0665789002" className="call-btn">
          <span className="phone-icon" style={{display: 'inline-flex', alignItems: 'center', marginRight: '6px'}}>
            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" fill="currentColor" viewBox="0 0 16 16">
              <path d="M3.654 1.328a.678.678 0 0 1 .252-.282c.272-.176.637-.145.893.07l2.29 1.958c.329.282.445.76.267 1.153l-.805 1.684a.678.678 0 0 0 .145.761l2.457 2.457a.678.678 0 0 0 .761.145l1.684-.805c.393-.178.87-.062 1.153.267l1.958 2.29c.215.256.246.621.07.893a.678.678 0 0 1-.282.252l-2.013.805c-.486.194-1.03.07-1.4-.3l-6.29-6.29c-.37-.37-.494-.914-.3-1.4l.805-2.013z"/>
            </svg>
          </span>
          Commandez
        </a>
      </div>
    </header>
  );
}

export default Header;